/**
 * This duck provides the Redux pieces to handle notifications.
 *
 * @todo Remember which notifications should be 'silenced'.
 */
import notifier from "../../utils/notifier";
import { fromEvent as notificationFromEvent } from "../../utils/notifications";

/**
 * Notify that a given event has happened.
 *
 * @see notifications
 */
const notifyEvent = (event) => () => {
  const notification = notificationFromEvent(event);
  if (notification) {
    notifier.notify(notification);
  }
};

const actionCreators = {
  notifyEvent,
};

export { actionCreators };
